import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { SeahorseThemeComponent } from '@seahorse/layout';
import { ContentDistributionHubService } from '../../content-distribution/services/content-distribution-hub.service';
import { HeaderComponent } from '../../layout/components/header/header.component';
import { SidebarComponent } from '../../layout/components/sidebar/sidebar.component';

@Component({
  selector: 'ca-app-theme',
  templateUrl: './customer-app-theme.component.html',
  imports: [
    CommonModule,
    SidebarComponent,
    HeaderComponent,
    SeahorseThemeComponent,
  ],
})
export class CustomerAppThemeComponent
  extends SeahorseThemeComponent
  implements OnInit, OnDestroy
{
  constructor(_contentDistributionHub: ContentDistributionHubService) {
    super();
    _contentDistributionHub.init();
  }
}
